import { render, staticRenderFns } from "./CompositionTable.vue?vue&type=template&id=2c5747d0&scoped=true"
import script from "./CompositionTable.vue?vue&type=script&lang=js"
export * from "./CompositionTable.vue?vue&type=script&lang=js"
import style0 from "./CompositionTable.vue?vue&type=style&index=0&id=2c5747d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5747d0",
  null
  
)

export default component.exports